<app-itopia-loader *ngIf="loading"></app-itopia-loader>
<div class="login-container" *ngIf="!loading ">
  <div class="glass-card">
  <div  fxLayoutAlign="center center" fxLayout="row">
       <img src="{{resources[0]}}" alt="cloudapps logo" class="logo" />
    </div>
    <h1 class="m-t-0 m-h1 ">Welcome to the<br>Admin Portal</h1>
    <p>Sign in using your organization’s account to manage your resources.</p>

       <div class="login-buttons">
            <button class="login-btn classlink" mat-stroked-button [disabled]="nycSubmited" (click)="signInWithNyc()">
                <img class="nyc" src="{{resources[1]}}" alt="NYC">
                Sign in with NYC
            </button>
    </div>   

    <div class="student-portal-button" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
        <div>
          <span>Not an Admin?</span>
        </div>
        <button mat-stroked-button color="primary" (click)="goToStudentPortal()">
            <mat-icon>open_in_new</mat-icon>
            Go to Student Portal
        </button>
     </div>
        <div class="progress" fxLayout="row" *ngIf="nycSubmited">
        <mat-progress-bar class="progress" mode="indeterminate"></mat-progress-bar>
    </div>
  </div>
   
</div>
